/**
 * Human-readable summary for an ENTITY_PROPERTY_CHANGED entry, e.g. "1 entity property was changed"
 * or "3 entity properties were changed". Shared between the table row and the detail modal so the
 * wording can't drift between the two.
 */
export function formatEntityPropertyChangedSummary(changedPropertiesDisplayNames: string[] | null | undefined): string {
    const count = changedPropertiesDisplayNames?.length ?? 0;
    return count === 1
        ? '1 entity property was changed'
        : `${count} entity properties were changed`;
}
